import React from "react";
import { Spinner } from "react-bootstrap";
import { isSelfId } from "../../../../../api/helper";
import { indexPosts } from "../../../../../api/posts";
import TweetBox from "../../../NewsFeed/TweetBox";
import PostsList from "../../../PostsList";

export default class Activity extends React.Component {
  state = {
    filter: {},
    pageSize: 5,
    pageNumber: 0,
    posts: null,
    loadingMore: false,
    canLoadMore: true,
  };
  componentDidMount() {
    this.fetchPosts();
    const element = document.getElementById("middle_col");
    if (element) {
      element.addEventListener("scroll", this.handleScroll);
    }
  }
  componentWillUnmount() {
    const element = document.getElementById("middle_col");
    if (element) {
      element.removeEventListener("scroll", this.handleScroll);
    }
  }
  fetchPosts = async () => {
    try {
      this.setState({ loadingMore: true });
      let { data } = await indexPosts({
        filter: { author_id: this.props.user.id, ...this.state.filter },
        page_number: this.state.pageNumber,
        page_size: this.state.pageSize,
      });
      const posts = data.posts || data.soundtracks;
      this.setState({
        posts: this.state.posts ? [...this.state.posts, ...posts] : posts,
        pageNumber: this.state.pageNumber + 1,
        canLoadMore: posts.length === this.state.pageSize,
      });
    } catch (error) {
      console.log(error);
      this.setState({ posts: [] });
    } finally {
      this.setState({ loadingMore: false });
    }
  };
  onPostCreated = (post) => {
    this.setState({
      posts: [post, ...this.state.posts],
    });
  };
  handleScroll = ({ target }) =>
    target.scrollHeight - target.offsetHeight - target.scrollTop <= 120 && !this.state.loadingMore && this.state.canLoadMore && this.fetchPosts();

  onFilterClick = async (filter) => {
    await this.setState({
      filter,
      pageNumber: 0,
      canLoadMore: true,
      posts: null,
    });
    await this.fetchPosts();
  };
  postsSetter = (newPost) =>
    this.setState({
      posts: this.state.posts.map((oldPost) => (oldPost.id === newPost.id ? newPost : oldPost)),
    });
  postsDeleter = (newPost) =>
    this.setState({
      posts: this.state.posts.filter((oldPost) => oldPost.id !== newPost),
    });

  updateData = (medium) => {
    const updatePosts = this.state.posts.map((om) => (medium.id === om.id ? medium : om));
    this.setState({ posts: updatePosts });
  };

  render() {
    return (
      <div id="newsfeed-page" className="newsfeed" style={{ margin: "1.5rem" }}>
        {isSelfId(this.props.user.id) && <TweetBox onPostCreated={this.onPostCreated} />}
        {
          <PostsList
            activityFillters
            user={this.props.user}
            onFilterClick={this.onFilterClick}
            postsSetter={this.postsSetter}
            postsDeleter={this.postsDeleter}
            posts={this.state.posts}
            filter={this.state.filter}
            setObject={this.updateData}
            refresh={() => {}}
          />
        }
        {this.state.loadingMore && (
          <div className="text-center">
            <Spinner as="span" animation="border" size="md" variant="light" style={{ marginRight: 20 }} />
          </div>
        )}
      </div>
    );
  }
}
